export default __webpack_public_path__ + "static/img5AR-5906e1abac76957eb25874491d0576cc.png";